import { render, staticRenderFns } from "./RoHFactsList.vue?vue&type=template&id=05b9b70c&"
import script from "./RoHFactsList.vue?vue&type=script&lang=js&"
export * from "./RoHFactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports